<template>
<!-- 平台活动 -->
<section class="viewContainer">
  <div v-show="isList">
    <el-col :span="24" class="order_toolbar toolbar pad_left">
      <!-- 查询区域 -->
      <div class="main_container" v-if="!oneId">
        <div class="fuji" @click="show3 = !show3">
          <p style="margin: 0; margin-left: -22px" class="goodslist1">
            <span style="margin-left: 31px; margin-top: 5px">搜索/查询</span>
            <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt/></span>
          </p>
          <div style="position: absolute; right: -19px; top: -10px" class="sanjiao"/>
        </div>
        <el-collapse-transition>
          <div style="padding: 0 12px" v-show="show3">
            <el-form :inline="true" :model="formInline" class="demo-form-inline findform">
              <el-form-item style="width: 100%; display: flex" label="活动标题：">
                <el-input v-model="name" placeholder="请输入活动标题关键字" maxlength="30" minlength="5"/>
              </el-form-item>
              <el-form-item style="display: flex; width: 100%" label="所属城市：">
                <el-cascader v-model="chengshi" placeholder="请选择城市" :options="options"
                  style="width: 100%" filterable clearable @change="handleChange"/>
              </el-form-item>
              <el-form-item label="状　　态：" style="display: flex; width: 100%" class="select">
                <el-select filterable v-model="stateId" placeholder="请选择" >
                  <el-option v-for="(item, index) in statearr" :key="index" :value="item.Id" :label="item.Name"/>
                </el-select>
              </el-form-item>
            </el-form>
            <el-form :inline="true" :model="formInline" class="demo-form-inline findform">
              <el-form-item style="display: flex; width: 34.1%" label="活动时间：" class="select">
                <el-date-picker v-model="value6" @change="handleChangeTime" style="width: 100%"
                  type="month" format="yyyy-MM" value-format="yyyy-MM"
                  placeholder="请选择活动年份或月份" @input="immediUpdate">
                </el-date-picker>
              </el-form-item>
              <el-form-item class="selectFormItem"/>
              <el-form-item class="selectFormItem" style="margin-left: 30px">
                <el-button type="danger" @click="onSubmit()" style="float: right">查 询</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-collapse-transition>
      </div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline findform" v-if="oneId" style="width: 98%; margin: 0 auto;">
        <el-form-item label="活动标题：" style="display: flex; width: 100%">
          <el-input v-model="name" placeholder="请输入活动标题关键字" maxlength="30" minlength="5"/>
        </el-form-item>
        <el-form-item label="状　　态：" style="display: flex; width: 100%" class="select">
          <el-select filterable v-model="stateId" placeholder="请选择">
            <el-option v-for="(item, index) in statearr" :key="index" :label="item.Name" :value="item.Id" />
          </el-select>
        </el-form-item>
        <el-form-item label="活动时间：" style="display: flex; width: 100%" class="select">
          <el-date-picker v-model="value6" @change="handleChangeTime" style="width: 100%"
            type="month" format="yyyy-MM" value-format="yyyy-MM" placeholder="请选择活动年份或月份" @input="immediUpdate">
          </el-date-picker>
        </el-form-item>
        <el-form-item class="twoBtnClass">
          <el-button type="danger" @click="showadd()" style="float: right;margin-left: 10px"> + 新 增 </el-button>
          <el-button type="danger" @click="onSubmit()" style="float: right">查 询</el-button>
        </el-form-item>
      </el-form>
    </el-col>
    <!-- 列表区域 -->
    <el-col :span="24" class="order_content main_container">
      <section class="model_section" v-if="!oneId">
        <p class="model_top_title">平台活动列表</p>
        <el-button type="danger" @click="showadd()" style="float: right;margin: 5px 10px 0 0;">+ 新 增</el-button>
      </section>
      <p v-if="oneId" style="margin-left: 20px">温馨提示：当前为{{oneName}}联盟活动列表</p>

      <div class="table_container">
        <div class="table_inner_container">
          <el-table :data="goodList" stripe border style="height: auto">
            <el-table-column label="序号" align="center" width="60px">
              <template scope="scope">{{scope.$index + 1}}</template>
            </el-table-column>
            <el-table-column prop="Title" label="活动标题" align="center">
              <template scope="scope">
                <span class="spanList" :title="scope.row.Title">{{ scope.row.Title }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="CityName" label="所属城市" align="center">
              <template scope="scope">
                <span class="spanList">{{ scope.row.CityName }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="EffectiveDate" align="center" label="活动时间" width="200px">
              <template scope="scope">
                <span class="spanList" :title="scope.row.EffectiveDate">{{ scope.row.EffectiveDate }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="SignUpCount" label="报名记录" align="center" width="80px">
              <template scope="scope">
                <span :style="{color: scope.row.SignUpCount == 0 ? '#ccc' : '#6786b4'}"
                  @click="popNum(scope)">{{ scope.row.SignUpCount }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="BeenCount" label="到场人数" align="center" width="80px">
              <template scope="scope"> <span>{{ scope.row.BeenCount }}</span> </template>
            </el-table-column>
            <el-table-column prop="BeenRate" label="到场率" align="center" width="80px">
              <template scope="scope"> <span>{{ scope.row.BeenRate }}</span> </template>
            </el-table-column>
            <el-table-column prop="OrderCount" label="活动订单" align="center" width="80px">
              <template scope="scope">
                <span :style="{color: scope.row.OrderCount == 0 ? '#ccc' : '#6786b4'}"
                  @click="activeNum(scope)">{{ scope.row.OrderCount }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="ConvertRate" label="转换率" align="center" width="80px">
              <template scope="scope"> <span>{{ scope.row.ConvertRate }}</span> </template>
            </el-table-column>
            <el-table-column prop="StateName" label="状态" align="center">
              <template scope="scope"> <span>{{ scope.row.StateName }}</span> </template>
            </el-table-column>
            <el-table-column label="操作" width="360px" fixed="right" align="center">
              <template scope="scope">
                <!-- 开启 -->
                <span class="handle" v-if="scope.row.State != 7 && scope.row.State == 4"
                  @click="openState(scope)"> <i class="el-icon-circle-check"></i>开启
                </span>
                <!-- 关闭 -->
                <span class="handle" v-if="scope.row.State != 7 && scope.row.State == 5"
                  @click="closeState(scope)"> <i class="el-icon-circle-close"></i>关闭
                </span>

                <span class="handle" @click="seeinfo(scope.row)"> <i class="el-icon-view"></i> 查看 </span>
                <span class="handle" v-if="scope.row.State == 4"
                  @click="emitinfo(scope.row)"> <i class="el-icon-edit-outline"></i> 编辑
                </span>
                <span class="handle" @click="handleyulan(scope.row)" v-show="scope.row.State == 4"> <i class="el-icon-view"></i> 预览 </span>

                <!-- <span class="handle" @click="CopyApplet(scope)" v-if="scope.row.State == 5"
                  v-clipboard:copy="message" v-clipboard:success="onError" v-clipboard:error="onError">
                  <i class="el-icon-paperclip"></i> 复制链接
                </span> -->

                <!-- 删除 -->
                <span class="handle" @click="deleteMerchant(scope.row)" v-show="scope.row.State==4||scope.row.State==6">
                  <i class="el-icon-delete"></i> 删除
                </span>

                <span class="handle" v-if="scope.row.State == 5" @click="scopeExtension(scope.row)">
                  <i class="el-icon-share" /> 物料
                </span>
                <span class="handle" @click="copyFun(scope)"> <i class="el-icon-printer"></i> 复制 </span>
                <span class="handle" @click="shuju(scope.row)" v-show="scope.row.State!=4"> <i class="el-icon-data-line"></i> 数据 </span>
                <span class="handle" @click="choujiang(scope.row)" v-if="scope.row.State == 5 || scope.row.State == 7">
                  <i class="el-icon-present"/> 抽奖
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="table_inner_container" style="margin-bottom: 10px">
          <el-pagination :current-page="pageIndex" :total="total" @current-change="handleCurrentChange"
            layout="prev, pager, next" :page-size="10" style="float: right; margin-top: 10px"/>
        </div>
      </div>
    </el-col>
    <!-- 报名人数 右侧抽屉组件 -->
    <el-drawer title="报名记录" custom-class="registrationRecord"
      :visible.sync="registrationRecordDrawer" direction="rtl" size="42%">
      <el-table :data="registrationRecordList" style="margin: 0px">
        <el-table-column property="Phone" label="用户电话" width="100" align="center"/>
        <el-table-column property="IsBeen" label="是否已到场" align="center"/>
        <el-table-column property="AttendMode" label="参会方式" align="center"/>
        <el-table-column property="BeenTime" label="到场记录" align="center"/>
        <el-table-column property="SignUpTime" label="报名时间" align="center"/>
      </el-table>
      <!-- 报名记录-分页 -->
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChangeBmrs" :page-size="10"
        :current-page="registrationRecordPageIndex" :total="registrationRecordTotal" style="float: right; margin-top: 10px"/>
    </el-drawer>
    <!-- 活动订单 右侧抽屉组件 -->
    <el-drawer title="活动订单" custom-class="registrationRecord" :visible.sync="activeOrderDrawer" direction="rtl" size="48%">
      <div class="dataDescription">
        <span>总订单数：<b>{{orderStatistics.OrderCount}}</b>,</span>
        <span> 订单总金额：<b>{{orderStatistics.OrderPrice}}</b>,</span>
        <span> 总报名人数：<b>{{orderStatistics.GrantCount}}</b>,</span>
        <span> 活动转换率：<b>{{orderStatistics.ConvertOrderRate}}</b></span>
      </div>
      <el-table :data="activeOrderList" style="margin: 0px">
        <el-table-column property="Name" label="用户昵称" align="center"/>
        <el-table-column property="Phone" label="用户电话" align="center"/>
        <el-table-column property="OrderType" label="订单类型" align="center"/>
        <el-table-column property="OrderNo" label="订单号" align="center">
          <template scope="scope">
            <!-- <span @click="jumpOrderDetail(scope.row, 2)" style="color: #6786b4; margin-left: 8px; cursor: pointer">{{ scope.row.OrderNo }}</span> -->
            <span class="spanList" :title="scope.row.OrderNo">{{ scope.row.OrderNo }}</span>
          </template>
        </el-table-column>
        <el-table-column property="Price" label="订单总金额" align="center"/>
        <el-table-column property="PayTime" label="支付时间" align="center"/>
      </el-table>
      <!-- 活动订单-分页 -->
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChangehddd" :page-size="10"
        :current-page="activeOrderPageIndex" :total="activeOrderTotal" style="float: right; margin-top: 10px"/>
    </el-drawer>
  </div>
  <!-- 新增/编辑弹框  :fullscreen="true" :modal="false"-->
  <section custom-class="activityDiaStyle" v-if="seeaddedit">
    <el-col :span="24" class="add_order_watch main_container pad_left">
      <section class="model_section" style="margin-bottom: 0">
        <el-col :span="14">
          <p class="model_top_title" style="font-weight: 500">
            {{ addActiveTitle }}
          </p>
        </el-col>
        <el-col :span="10">
          <p @click="hideAddActiveDia()" class="add_new_btn">关闭</p>
        </el-col>
      </section>
      <activityFormList ref="activityFormList" @cancleAddBaseMsg="cancleAddBaseMsg" v-show="showhdlist"/>
    </el-col>
  </section>
  <!-- 微信扫码支付 -->
  <el-dialog title="请使用微信扫码支付" :visible.sync="wxsmzfVisible" width="20%" center @close="closeWxsmzf()">
    <div class="wxsmzfClass">
      <P>{{wxsmzfJine}} 元</P>
      <img :src="wxSmzfImg"/>
    </div>
  </el-dialog>
  <!-- 抽奖规则配置-弹框 -->
  <el-dialog title="抽奖规则配置" :visible.sync="cjgzpz" :center="true" width="50%">
    <div>
      <div style="margin-bottom: 10px;">
        <b>订单时间范围：</b>
        <el-date-picker type="daterange" v-model="ddsjfwTime" @change="changeActiveTime"
        width="300px" align="right" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期"
        style="width:50%;cursor:pointer;background:#fff;border:1px solid #eee;"/>
        <span style="color: #F56C6C;float: right;margin-top: 8px;"><i class="el-icon-info"/> 该时间段满足条件订单数据进入奖池</span>
      </div>
      <div style="margin-bottom: 10px;">
        <b>订单金额要求：</b>
        最低　<el-input v-model="ddjeyq" placeholder="请输入" style="width:100px" maxlength="10"
        onkeyup="this.value=this.value.replace(/\D|^0/g,'')"/>　元
        <span style="color: #F56C6C;float: right;margin-top: 8px;"><i class="el-icon-info"/> 满足该金额的订单才可以进入抽奖池</span>
      </div>
      <div style="margin-bottom: 10px;">
        <b>抽奖机会份数：</b>
        每满　<el-input v-model="cjjhfs" placeholder="请输入" style="width:100px" maxlength="10"
        onkeyup="this.value=this.value.replace(/\D|^0/g,'')"/>　元，奖池增加一份记录，提高中奖机会。
      </div>
      <p style="color: #F56C6C;">温馨提示：抽奖基础数据是本活动期间订单数据</p>
    </div>
    <div style="text-align:center">
      <el-button @click="cjgzpz = false">取消</el-button>
      <el-button type="danger" @click="kscj()">开始抽奖</el-button>
    </div>
  </el-dialog>
  
  <!-- 确认提示 -->
  <el-dialog title='确认提示' :visible.sync="fufeidialog" width="25%" center>
    <div style="text-align:center;">
      <p style="margin: 10px 0 20px 0; font-size: 16px;">确定要支付推广费用后开启活动吗?</p>
      <b style="font-size: 18px;">-{{zysj}} 元</b>
    </div>
    <div style="text-align:center;margin-top: 20px;">
      <el-button @click="fufeidialog = false">取消</el-button>
      <el-button type="danger" @click="qdfufeu()">确定</el-button>
    </div>
  </el-dialog>
  
  <!-- 充值提示 -->
  <el-dialog title='充值提示' :visible.sync="chongzhidialog" width="25%" center>
    <div style="text-align:center;">
      <p style="margin: 10px 0 30px 0; font-size: 16px;">{{chognzhitishi}}</p>
    </div>
    <div style="text-align:center;">
      <el-button @click="chongzhidialog = false">取消</el-button>
      <el-button type="danger" @click="quchongzhi()">去充值</el-button>
    </div>
  </el-dialog>

  <!-- 预览 -->
  <el-dialog title='请使用微信扫码后进行预览' :visible.sync="yldialog" width="20%" center>
    <div style="text-align:center;margin-bottom: 20px;">
      <img :src="yulanUrl" style="width: 100%;"/>
    </div>
    <div style="text-align:center;">
      <el-button @click="yldialog = false" style="width: 30%;height: 50px;background: #F56C6C;color: #fff;">关闭</el-button>
    </div>
  </el-dialog>

</section>
</template>
<script>
import { postPlaceOrderNative, payment } from "../../api/newOss";
import { postActivityRechargeRefunds, getIsRecharge, getCloseActivity, getGeneratedActivityQrCode, getCopyActivity,
  getAllProvinceAndCityList, getActivityStatus, getActivityList, getActivityRegistrationRecord, getActivityConvertOrder,
  getActivityConvertStatistics, getDeleteActivity, activityPreview, } from "../../api/activityFormList";
import activityFormList from "../../components/activity/activityFormList";
import { getplayerrange, postplayerrangesave } from "../../api/shopWindow";
export default {
  name: 'ActivityManagementList',
  data() {
    return {
      activeListData:[],
      // 特价商品表单
      addActiveTitle: "新增/编辑活动",
      addActive: 0, //默认的活动编辑的步骤进度

      isList: true, // 列表
      seeaddedit: false, // 新增活动
      showhdlist: true, // 活动形式

      registrationRecordDrawer: false, //报名记录右侧弹框
      registrationRecordList: [], //报名记录列表
      registrationRecordPageIndex: 1, //报名记录分页页码
      registrationRecordTotal: 0, //报名记录总条数

      activeOrderDrawer: false, //活动订单右侧弹框
      activeOrderList: [], //活动订单列表
      activeOrderPageIndex: 1, //活动订单分页页码
      activeOrderTotal: 0, //活动订单总数

      orderStatistics: [], // 订单统计

      rooid: "", // rooid
      isEditOrAddOrSee:0, // 增改查

      goodList: [],
      name: "", // 活动标题
      provinceId: 0, // 省id
      cityId: 0, // 市id
      stateId: 0, // 状态
      sTime: "", // 年
      eTime: "", // 月
      pageIndex: 1, // 页码
      total: 0,
      value6: "", // 活动时间
      
      statearr: [], // 状态
      message: "113",
      show3: false,
      formInline: {},
      chengshi: "",
      tbdprovince: [],
      tbdcity: [],
      options: [
        {
          value: 0,
          label: "全部",
        },
      ],
      oneStepformData:'',
      editActivityId: "", // 活动id
      wxsmzfVisible: false, // 微信扫码支付
      wxsmzfJine: '', // 金额
      wxSmzfImg: '', // 二维码

      timer: null, // 轮询
      startTime: 0, // 初始开始请求时间
      listId: '',
      
      cjgzpz: false, // 抽奖规则配置
      ddsjfwTime: [], // 订单时间范围
      startddTime: '',
      endddTime: '',
      ddjeyq: '',
      cjjhfs: '',
      
      fufeidialog: false, // 确认提示
      zysj: 0, // 金额
      chongzhidialog: false, // 充值提示
      chognzhitishi: '', // 提示文案

      yldialog: false,
      yulanUrl: '',
      
    };
  },
  props:['oneId','oneName', 'bbid'], // 接手oneId值
  components: {
    activityFormList, //活动形式
  },
  methods: {
    // 关闭
    hideAddActiveDia() {
      this.seeaddedit = false;
      this.isList = true; // 列表
      this.getActiveList();
    },
    // 取消添加活动
    cancleAddBaseMsg() {
      this.seeaddedit = false;
      this.isList = true; // 列表
      this.getActiveList();
    },
    // 新增特价商品
    // showAddActiveForm() {
    //   this.addActiveTitle = "特价商品";
    //   this.addActive = 1;
    // },
    // 点击活动订单中的订单号跳转到订单详情页面
    jumpOrderDetail(row) {
      this.$router.push({
        path: "/order",
        query: {
          type: 1,
          Id: row.Id,
        },
      });
    },
    // getUrlBase64这个方法主要根据图片的url返回一个base64编码
    getUrlBase64(url) {
      return new Promise(resolve => {
        let canvas = document.createElement('canvas')
        let ctx = canvas.getContext('2d')
        let img = new Image()
        img.crossOrigin = 'Anonymous' //允许跨域
        img.src = url
        img.onload = function() {
          canvas.width = 1280
          canvas.height = 1280
          ctx.drawImage(img, 0, 0, 1280, 1280)
          let dataURL = canvas.toDataURL('image/png')
          canvas = null
          resolve(dataURL)
        }
      })
    },
    // 删除
    deleteMerchant(row) {
      this.$swal({
        type: "warning",
        text: "重要信息，你确定要删除吗？",
        showCancelButton: true,
        reverseButtons: true, // 添加这一行来反转按钮顺序
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      }).then((res) => {
        if (res.value) {
          var obj = {
            activityid: row.Id
          };
          getDeleteActivity(obj).then(data => {
            if (data.resultCode == 1) {
              this.showAlert('删除成功', 'success');
              this.getActiveList();
            }
          });
        }
      });
    },
    // 物料
    scopeExtension(row) {
      var obj = {
        activityId: row.Id, // 活动id
        activityName: row.Title, // 活动名称
      };
      getGeneratedActivityQrCode(obj).then(data=>{
        if(data.ResultCode == 1){
          // data.ResultObj
          let address = data.ResultObj;
          let intercept = data.ResultMsg;
          this.getUrlBase64(address).then(base64 => {
            let link = document.createElement('a')
            link.href = base64
            link.download = intercept
            link.click()
          })
          this.$swal({
            type:"success",
            text:"下载成功"
          })
        }
      })
    },
    // 查询
    onSubmit() {
      this.pageIndex = 1;
      this.getActiveList();
    },
    //获取活动列表
    getActiveList(val) {
      if(val==1){
        this.pageIndex = val;
      }
      if(this.oneId) {
        localStorage.setItem('lianmengId',this.oneId);
      } else {
        localStorage.setItem('lianmengId','');
      }
      // let lmid = localStorage.getItem("lianmengId");
      var obj = {
        UserId: localStorage.Id,
        Title: this.name,
        ProvinceId: this.provinceId,
        CityId: this.cityId,
        State: this.stateId,
        Year: this.sTime,
        Month: this.eTime,
        PageIndex: this.pageIndex, // 页码
        PageSize: 10,
        MaId: this.oneId?this.oneId:0, // 联盟id（新增参数）平台活动、店铺活动固定为0
        SponsorType: 4, // 1：平台、2：店铺活动、4：联盟活动
      };
      getActivityList(obj).then((data) => {
        if (data.ResultCode == 1) {
          this.goodList = data.ResultObj;
          this.total = data.RowsCount;
        } else if (data.ResultCode == 4) {
          this.goodList = [];
          this.total = 0;
        } else {
          this.goodList = [];
          this.total = 0;
        }
      });
    },
    // 重置
    fnReset() {
      this.name = "";
      this.chengshi = "";
      this.provinceId = 0;
      this.cityId = 0;
      this.stateId = 0;
      this.value6 = "";
      this.sTime = 0;
      this.eTime = 0;
      this.pageIndex = 1;
      this.getActiveList();
    },
    // 查询活动列表分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getActiveList();
    },
    // 点击报名人数
    popNum(scope) {
      if (scope.row.SignUpCount == 0) {
        // this.$swal({
        //   type:"warning",
        //   text:"无报名人数"
        // })
        return;
      }
      this.rooid = scope.row.Id;
      this.registrationRecordDrawer = true;
      this.getPopNum(); //报名记录列表
    },
    // 查询报名人数列表
    getPopNum() {
      var obj = {
        ActivityId: this.rooid,
        PageIndex: this.registrationRecordPageIndex, // 入参 报名人数页码
        PageSize: 10,
      };
      getActivityRegistrationRecord(obj).then((data) => {
        if (data.ResultCode == 1) {
          this.registrationRecordList = data.ResultObj;
          this.registrationRecordTotal = data.RowsCount;
        } else {
          this.registrationRecordList = [];
        }
      });
    },
    // 查询报名人数分页
    handleCurrentChangeBmrs(val) {
      this.registrationRecordPageIndex = val;
      this.getPopNum();
    },

    // 点击活动订单
    activeNum(scope) {
      if (scope.row.OrderCount == 0) {
        // this.$swal({
        //   type:"warning",
        //   text:"无活动订单"
        // })
        return;
      }
      this.rooid = scope.row.Id;
      this.activeOrderDrawer = true;
      
      // 调用 获取活动转换订单统计
      var obj = {
        activityId: this.rooid,
      };
      getActivityConvertStatistics(obj).then((data) => {
        if (data.ResultCode == 1) {
          this.orderStatistics = data.ResultObj;
        } else {
          this.orderStatistics = [];
        }
      });

      this.getActiveNum(); // 活动订单列表
    },
    // 查询活动订单列表
    getActiveNum() {
      var obj = {
        ActivityId: this.rooid,
        PageIndex: this.activeOrderPageIndex, // 入参 活动订单页码
        PageSize: 10,
      };
      getActivityConvertOrder(obj).then((data) => {
        if (data.ResultCode == 1) {
          this.activeOrderList = data.ResultObj;
          this.activeOrderTotal = data.RowsCount;
        } else {
          this.activeOrderList = [];
        }
      });
    },
    // 查询活动订单分页
    handleCurrentChangehddd(val) {
      this.activeOrderPageIndex = val;
      this.getActiveNum();
    },
    //时间选择器修改
    handleChangeTime(val) {
      let newVal = val.split("-");
      if (newVal == null) {
        this.sTime = "";
        this.eTime = "";
        return false;
      }
      this.sTime = newVal[0];
      this.eTime = newVal[1];
    },
    // 活动时间控件 做清空处理
    immediUpdate(e) {
      this.$nextTick(() => {
        if(e==null){
          this.sTime='';
          this.eTime='';
        }
      });
    },
    //新增
    showadd() {
      this.isEditOrAddOrSee = 0;
      this.isList = false; // 列表
      this.seeaddedit = true; // 详情页
      this.showhdlist = true; // 活动形式
      this.addActive=2;
      this.$nextTick(() => {
        this.$refs.activityFormList.initComponent(this.isEditOrAddOrSee,'',this.oneId?this.oneId:0,4);
      })
    },
    //编辑
    emitinfo(row) {
      this.editActivityId = row.Id;
      this.isEditOrAddOrSee = 1;
      this.isList = false; // 列表
      this.seeaddedit = true; // 详情页
      this.showhdlist = true; // 活动形式
      this.addActive=2;
      this.$nextTick(() => {
        this.$refs.activityFormList.initComponent(this.isEditOrAddOrSee,row.Id,this.oneId?this.oneId:0,4);
      })
    },
    //查看
    seeinfo(row) {
      this.editActivityId = row.Id;
      this.isEditOrAddOrSee = 2;
      this.isList = false; // 列表
      this.seeaddedit = true; // 详情页
      this.showhdlist = true; // 活动形式
      this.addActive=2;
      this.$nextTick(() => {
        this.$refs.activityFormList.initComponent(this.isEditOrAddOrSee,row.Id,this.oneId?this.oneId:0,4);
      })
    },
    // 预览
    handleyulan(row){
      this.yldialog = true;
      let obj = {
        activityid: row.Id, // 活动ID
        shopid: this.bbid // 店铺ID
      }
      activityPreview(obj).then(data => {
        if(data.resultCode == 1) {
          this.yulanUrl = data.resultObj; // 活动预览码图片地址 完整路径
        }
      })
    },
    // 退款
    tuikuan(){
      let addObjTwo = '';
      // let addObjTwo = {
      //   activityId: this.tgjlId // 活动id
      // }
      postActivityRechargeRefunds(addObjTwo, this.tgjlId).then(data => {
        if(data.resultCode == 1) {
          this.$swal({
            type:"success",
            text:"退款申请成功，余额将返回原支付微信账户，请注意查收。"
          })
        }
      })
    },
    // 开启
    openState(scope) {
      this.listId = scope.row.Id; // 获取选中行id
      this.State = scope.row.State; // 开启权限
      this.deduction(0); // 调取支付0
    },
    // 确定开启
    kaiqi(){
      var text = "";
      if (this.State == 4 || this.State == 6) {
        text = "您确定开启吗？";
      }
      this.$swal({
        type: "warning",
        text: text,
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      }).then((res) => {
        if (res.value) {
          this.deduction(1); // 调取支付1
        }
      });
    },
    // 确定
    qdfufeu(){
      this.fufeidialog=false;
      this.deduction(1); // 调取支付1
    },
    // 支付接口
    deduction(val){
      var obj = {
        attach: 'activityrechargeorder,' + this.listId,
        price: 0, // 支付金额 单位：元 （店铺分享赚钱必传）
        operatorid: localStorage.Id, // 操作人
        isconfirm: val, // 是否确认支付 0=否 1=是 （非确认支付只返回支付金额 单位：元）
      };
      payment(obj,3,this.bbid).then(data => {
        if (data.resultCode == 1) {
          this.zysj = data.resultObj; // 返回金额 - 待确认支付：返回待支付金额 单位：元 确认支付：>0表示成功
          if(this.zysj>0){
            this.fufeidialog=true;
          }else if(this.zysj==0){
            this.kaiqi();
          }else{
            this.$swal({
              type: "success",
              text: "开启成功",
            });
            this.getActiveList();
          }
        }else if(data.resultCode == 4){
          this.chongzhidialog=true; // 充值提示
          this.chognzhitishi=data.resultObj; // 提示文案
        }else{
          this.$swal({
            type: "warning",
            text: data.resultMsg,
          })
        }
      });
      // postPlaceOrderNative(obj).then((data) => {
      //   if (data.ResultCode == 1) {
      //     this.wxsmzfVisible = true;
      //     this.wxsmzfJine = data.resultObj.price; // 金额（单位0）
      //     this.wxSmzfImg = data.resultObj.qrCode; // resultCode=1时返回base64格式二维码图片
          
      //     this.startTime = new Date().getTime() // 获取触发轮询时的时间
      //     this.inquireData() // 调用轮询接口,开始进行轮询
          
      //   } else if(data.ResultCode == 4) {
      //     this.$swal({
      //       type: "success",
      //       text: "开启成功",
      //     });
      //     this.getActiveList();
      //   }
      // });
    },
    // 去充值
    quchongzhi(){
      this.$router.push({
        path: "/vmacount", // 跳转店铺钱包
        query: { shopid: this.bbid }
      });
    },
    
    // 二维码弹框-关闭
    closeWxsmzf() {
      this.wxsmzfVisible = false; // 二维码弹窗消失
      clearTimeout(this.timer)
    },
    // 轮询请求
    inquireData() {
      const reload = () => {
        clearTimeout(this.timer) // 清除定时器
        // 超过30分钟则停止轮询
        if (new Date().getTime() - this.startTime > 5 * 60 * 1000) {
          clearTimeout(this.timer)
          return
        }
        // 3s一次, 轮询中
        this.timer = setTimeout(() => {
          this.inquireData() // 调用轮询
        }, 1000)
      }
      let lxObj = {
        activityId: this.listId // 活动id
      }
      getIsRecharge(lxObj).then(res => {
        if (res && res.resultCode === 1) {
          // true=已充值、false = 未充值
          if(res.resultObj) {
            this.wxsmzfVisible = false; // 二维码弹窗消失
            this.$swal({
              type: "success",
              text: "开启成功",
            });
            this.getActiveList();
          } else {
            reload() // 没成功,调用轮询
          }
        } else {
          reload() // 没成功,调用轮询
        }
      }).catch(err => {
        reload() // 请求错误,也继续轮询
      })
    },
    // 关闭
    closeState(scope) {
      var text = "";
      if (scope.row.State == 5) {
        text = "您确定关闭吗？";
      }
      this.$swal({
        type: "warning",
        text: text,
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      }).then((res) => {
        if (res.value) {
          var obj = {
            activityId: scope.row.Id
          };
          getCloseActivity(obj).then((data) => {
            if (data.ResultCode == 1) {
              this.$swal({
                type: "success",
                text: "操作成功",
              });
              this.getActiveList();
            }
          });
        }
      });
    },
    
    // 复制链接
    CopyApplet(scope) {
      this.message = scope.row.WxUrl;
      console.log(this.message,'微信小程序路径');
    },
    // 复制链接
    onError: function (e) {
      this.$swal({
        type: "success",
        text: "复制链接成功",
      });
    },
    // 复制
    copyFun(scope) {
      var obj = {
        ActivityId: scope.row.Id, // 活动id
        OperatorId: localStorage.Id // 操作人id
      };
      getCopyActivity(obj).then((data) => {
        if (data.ResultCode == 1) {
          this.$swal({
            type: "success",
            text: "复制成功",
          });
          this.getActiveList();
        }
      });
    },
    // 状态
    getStatearr() {
      var obj = {
        type: "1", // 1：平台；2：店铺活动
      };
      getActivityStatus(obj).then((data) => {
        if (data.ResultCode == 1) {
          this.statearr = data.ResultObj;
          this.statearr.unshift({
            Id: 0,
            Name: "全部",
          });
        }
      });
    },
    // 数据
    shuju(row) {
      this.$router.push({
        path: "/activityDataList", // 活动-数据
        query: { Id: row.Id, type: 1 },
      });
    },
    // 抽奖
    choujiang(row) {
      this.listId = row.Id; // 获取选中行id
      this.cjgzpz = true;
      getplayerrange('',2,row.Id).then(data => {
        if (data.resultCode == 1) {
          this.startddTime = data.resultObj.bdate;
          this.endddTime = data.resultObj.edate;
          this.ddsjfwTime = [data.resultObj.bdate,data.resultObj.edate];
          this.ddjeyq = data.resultObj.limitprice; // 取数金额最低要求(订单金额要求) 单位：元
          this.cjjhfs = data.resultObj.playercountprice; // 抽奖名额增加条件(满多少钱加一个名额) 单位：元
        }else{
          // 获取列表时间
          let sTime = row.EffectiveDate.split('-');
          this.startddTime = sTime[0]+'-'+sTime[1]+'-'+sTime[2];
          this.endddTime = sTime[3]+'-'+sTime[4]+'-'+sTime[5];
          this.ddsjfwTime = [this.startddTime,this.endddTime];
          this.ddjeyq = '';
          this.cjjhfs = '';
        }
      });
    },
    // 开始抽奖
    kscj(){
      if (!this.ddsjfwTime) {
        this.$swal({
          type: "warning",
          text: "请选择订单时间范围",
        });
        return false;
      }
      if (!this.ddjeyq) {
        this.$swal({
          type: "warning",
          text: "请输入订单金额",
        });
        return false;
      }
      if (!this.cjjhfs) {
        this.$swal({
          type: "warning",
          text: "请输入抽奖机会份数",
        });
        return false;
      }
      if (Number(this.ddjeyq) < Number(this.cjjhfs)) {
        this.$swal({
          type: "warning",
          text: "配置错误，每满金额数值须小于等于订单最低金额。",
        });
        return false;
      }
      let obj = {
        operatorid: localStorage.Id, // 操作人id
        configtype: 2, // 配置类型 1=店铺活动 2=联盟活动配置
        businessid: this.listId, // 业务主键ID（活动ID）
        bdate: this.startddTime, // 开始
        edate: this.endddTime, // 结束
        limiteprice: this.ddjeyq,
        playercountprice: this.cjjhfs,
        belongid: this.oneId, // 归属ID(店铺ID或联盟ID，根据configtype区分)
      }
      postplayerrangesave(obj).then(data => {
        if (data.resultCode == 1) {
          this.cjgzpz = false;
          let pathInfo = this.$router.resolve({
            path:'/eventlottery', // 活动抽奖
            query:{
              yyqid: this.listId,
              yyqtype: 3, // 联盟活动抽奖
            }
          })
          window.open(pathInfo.href, '_blank');
        }else {
          this.$swal({
            type: "warning",
            text: data.resultMsg,
          });
        }
      });
    },
    // 订单时间范围
    changeActiveTime(e) {
      this.$nextTick(() => {
        if (e == null) {
          this.startddTime = ''
          this.endddTime = ''
        } else {
          this.$set(this, 'ddsjfwTime', [e[0], e[1]])
          this.startddTime = this.ddsjfwTime[0]
          this.endddTime = this.ddsjfwTime[1]
        }
      })
    },
    // 请选择省市
    handleChange(val) {
      this.provinceId = val[0];
      this.cityId = val[1];
    },
    //查找省
    getprovince() {
      var loginParams = {
        isOpen: 1,
        userId: localStorage.Id
      };
      getAllProvinceAndCityList(loginParams).then(data => {
        let that = this;
        let provinceAndCityAndarea = [];
        data.ResultObj.map(item => {
          // 省
          let provinceData = {value:item.Id,label:item.Name,children:[]};
          provinceAndCityAndarea.push(provinceData);
          // 市
          item.CityList.map(city => {
            let cityData = {value:city.Id, label:city.Name};
            provinceData.children.push(cityData);
          })
        });
        that.options = provinceAndCityAndarea;
      })
    },
  },
  beforeDestroy () {
    clearTimeout(this.timer)
  },
  mounted() {
    this.getprovince(); // 省市
    this.getStatearr(); // 状态
    this.getActiveList(); // 查询列表
  },
};
</script>
<style scoped>
.selectFormItem {
  width: 33.33%;
  display: flex;
}
.twoBtnClass {
  width: 50%;
}
</style>


// WEBPACK FOOTER //
// ActivityManagementList.vue?145c4570